
import { useLoaderData, useRouteLoaderData  } from "react-router";
import type { loader as siteLayoutLoader } from "~/layout/public/site-layout";
import ContactForm from "./contact-form";

export default function ContactSection() {
    const data = useRouteLoaderData<typeof siteLayoutLoader>("site-layout");
    const { formRef, formSig } = useLoaderData<{formRef: string, formSig: string}>();
  //console.log("Form Reference:", formRef);
  //console.log("Form Signature:", formSig);

    return (
        <section id="contact" className="contact">
            <div className="mb-5" data-aos="fade-up" data-aos-delay="200">
                <iframe style={{ border: 0, width: "100%", height: "300px" }} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2487.872271613362!2d-0.1663335231250063!3d51.423772916808915!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4876071b088c5abd%3A0xc02d02ec0ef11da7!2sConstellation%20Training!5e0!3m2!1sen!2suk!4v1742849843131!5m2!1sen!2suk" frameBorder="0" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>

            </div>
            <div className="container">
                <div className="row mt-5">
                    <div className="col-lg-4 mb-4">
                        <div className="info">
                            <div className="address">
                                <i className="bi bi-geo-alt"></i>
                                <h4>Location:</h4>
                                <p>Constellation Training has It&apos;s working office in London, covering the whole of England and Wales</p>
                                <p>&nbsp;</p>
                                <p><strong>London</strong><br />Tooting Works Business Centre,<br />89 Bickersteth Rd, <br />London SW17 9SH</p>
                            </div>

                            <div className="email">
                                <i className="bi bi-envelope"></i>
                                <h4>Email:</h4>
                                <p>{data?.contactEmail}</p>
                            </div>

                            <div className="phone">
                                <i className="bi bi-phone"></i>
                                <h4>Call:</h4>
                                <p>
                                    <a href={`tel:${data?.machinePhoneNumber}`} className="d-block d-lg-none">
                                        {data?.phoneNumber}
                                    </a>
                                    <span className="d-none d-lg-inline">
                                        {data?.phoneNumber}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <ContactForm formRef={formRef} formSig={formSig} subjectOverride={null} />
                </div>
            </div>
        </section>
    )
}